import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";

const AcceptInvitation = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    const processInvitation = async () => {
      const token = searchParams.get("token");

      if (!token) {
        navigate("/auth");
        return;
      }

      try {
        // Track the acceptance
        const { data, error } = await supabase.functions.invoke(
          "track-invitation-response",
          {
            body: {
              tracking_token: token,
              action_type: "accepted",
            },
          }
        );

        if (error) throw error;

        if (data?.invitation) {
          // Store invitation data in session storage for signup page
          sessionStorage.setItem("invitation_data", JSON.stringify(data.invitation));
          
          // Redirect to signup
          navigate(`/signup-from-invitation?token=${token}`);
        } else {
          throw new Error("Invalid invitation");
        }
      } catch (error) {
        console.error("Error processing invitation:", error);
        navigate("/auth");
      } finally {
        setIsProcessing(false);
      }
    };

    processInvitation();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin mx-auto mb-4 text-primary" />
        <p className="text-lg">Processing your invitation...</p>
      </div>
    </div>
  );
};

export default AcceptInvitation;
